import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { BASE_URL } from "../../../Helpers";
import axios from "axios";
import hotSale from "../../../../src/assets/static/hot_sale/alohar-hot-sale.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
import HotSaleButton from "../../Buttons/HotSaleButton";
import { truncar } from "../../../utilities/truncar";
import styles from "./housingPromotions.module.css";
import SuggestedSkeleton from "../../../containers/Utils/SuggestedSkeleton";

import levelPlatinium from "../../../../src/assets/static/housing-promotions/bandas-plata-borde.png";
import levelGold from "../../../../src/assets/static/housing-promotions/bandas-dorado-borde.png";

// ✅ AGREGAR: Importar CSS de Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const HousingPromotions = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hotSaleActive, setHotSaleActive] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setLoading(true);

    const url = `${BASE_URL}/housing-promotions/v2?page=${currentPage}&pageSize=10`;

    axios
      .get(url)
      .then((response) => {
        // Manejar diferentes estructuras de respuesta
        if (Array.isArray(response.data)) {
          setItems(response.data);
        } else if (response.data.data && Array.isArray(response.data.data)) {
          setItems(response.data.data);
        } else if (response.data.items && Array.isArray(response.data.items)) {
          setItems(response.data.items);
        } else {
          setItems(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching housing promotions:", error);
        setLoading(false);
      });
  }, [currentPage]);

  // Add this useEffect to activate the hot sale button when there are active hot sales
  useEffect(() => {
    if (items.length > 0) {
      // Check if there are any items with hot sale status (0 or 2)
      const hasHotSaleItems = items.some((item) => [0, 2].includes(item.status));
      setHotSaleActive(hasHotSaleItems);
    }
  }, [items]);

  const handleSlideChange = (swiper) => {
    const activeIndex = swiper.activeIndex;
    const slidesPerView = swiper.params.slidesPerView;
    const totalSlides = swiper.slides.length;

    const slidesRemaining = totalSlides - activeIndex;

    // if (items.length === activeIndex + 4) {
    //   getHousingPromotions(currentPage + 1);
    // }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Si está cargando, muestra el skeleton
  if (loading) {
    return <SuggestedSkeleton />;
  }

  // Si no hay items después de cargar, no mostrar la sección
  if (!loading && items.length === 0) {
    return null;
  }

  return (
    <>
      {/* ✅ AGREGAR: CSS personalizado para ocultar texto de Swiper */}
      <style jsx>{`
        .housing-promotions-prev::after,
        .housing-promotions-next::after,
        .housing-promotions-prev:after,
        .housing-promotions-next:after {
          content: '' !important;
          display: none !important;
        }
        
        .housing-promotions-prev,
        .housing-promotions-next {
          font-family: inherit !important;
        }
        
        .housing-promotions-swiper .swiper-button-prev:after,
        .housing-promotions-swiper .swiper-button-next:after {
          content: '' !important;
          display: none !important;
        }
      `}</style>

      {false && hotSaleActive && <HotSaleButton />}

      <section
        className={`flex relative flex-col sm:justify-center items-center pt-28 pb-6 sm:py-0 pl-[5%] sm:pl-0 sm:rounded-[10vw]`}
      >
        <div className="relative flex flex-col w-full">
          <h2 className="text-black sm:pl-[5%] sm:text-[64px] text-[45px] font-castaBold">
            Sugeridos
          </h2>

          <div className={` w-full `}>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={
                windowWidth > 1050
                  ? 4
                  : windowWidth > 800
                  ? 3
                  : windowWidth > 700
                  ? 2
                  : 1
              }
              onSlideChange={handleSlideChange}
              navigation={{
                nextEl: `.housing-promotions-next`,
                prevEl: `.housing-promotions-prev`,
                disabledClass: 'swiper-button-disabled',
              }}
              pagination={{
                clickable: true,
                dynamicBullets: true,
                el: `.housing-promotions-pagination`,
              }}
              lazy={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              className="sm:px-[5%] pb-12 housing-promotions-swiper"
            >
              {/* ✅ CAMBIO: Botones personalizados sin clases de Swiper que generan texto */}
              <button
                className="housing-promotions-prev flex items-center justify-center text-white"
                style={{
                  background: "#FF4E00",
                  borderRadius: "100%",
                  padding: "0",
                  width: "34px",
                  height: "34px",
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "inherit",
                }}
              >
                ‹ {/* ✅ CAMBIO: Carácter de flecha más limpio */}
              </button>
              <button
                className="housing-promotions-next flex items-center justify-center text-white"
                style={{
                  background: "#FF4E00",
                  borderRadius: "100%",
                  padding: "0",
                  width: "34px",
                  height: "34px",
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  border: "none",
                  cursor: "pointer",
                  fontSize: "18px",
                  fontWeight: "bold",
                  fontFamily: "inherit",
                }}
              >
                › {/* ✅ CAMBIO: Carácter de flecha más limpio */}
              </button>

              {items.map((item, index) => (
                <SwiperSlide className="sm:rounded-[10vw]" key={index}>
                  {(() => {
                    const safePath =
                      item?.housing?.location?.location && item?.housing?.id
                        ? `${item.housing.location.location}/property/${item.housing.id}`
                        : "/";
                    return (
                  <Link
                    to={safePath}
                    className="relative rounded-[20px] bg-white w-11/12 gap-[10px] overflow-hidden flex flex-col"
                  >
                    <div className="relative w-full rounded-[20px] h-[70vw] sm:h-[12vw] ">
                      {[1, 2].includes(item.status) &&
                        item?.priorityLevel?.name === "platinum" && (
                          <img
                            src={levelPlatinium}
                            alt="Hot sale"
                            className="absolute w-[45%] top-0 left-0 z-50"
                          />
                        )}
                      {[1, 2].includes(item.status) &&
                        item?.priorityLevel?.name === "gold" && (
                          <img
                            src={levelGold}
                            alt="Hot sale"
                            className="absolute w-[45%] top-0 left-0 z-50"
                          />
                        )}
                      {[0, 2].includes(item.status) && (
                        <img
                          src={hotSale}
                          alt="Hot sale"
                          className="absolute z-50 w-10 top-1 right-2"
                        />
                      )}
                      <img
                        className="object-cover w-full h-full  rounded-[20px]"
                        src={`${BASE_URL}/${item.housing.housingMedia[0]?.media.replace(
                          "public/",
                          ""
                        )}`}
                        alt="Alojamiento"
                        onError={(e) => {
                          e.target.src = 'data:image/svg+xml;base64,' + btoa(`
                            <svg width="400" height="300" xmlns="http://www.w3.org/2000/svg">
                              <rect width="100%" height="100%" fill="#E5E7EB"/>
                              <text x="50%" y="50%" text-anchor="middle" dy="0.3em" font-family="Arial, sans-serif" font-size="16" fill="#6B7280">Imagen no disponible</text>
                            </svg>
                          `);
                        }}
                      />
                      {[0, 2].includes(item.status) && (
                        <span className="absolute font-robotoRegular bottom-[-7.5%] right-[5%] px-2 py-2 text-sm leading-none text-white bg-primary rounded-[8px] ">
                          {item.discount}% OFF
                        </span>
                      )}
                    </div>
                    <div className="flex flex-col ">
                      <div className="pl-[5%]  flex flex-col justify-between h-full gap-[10px] ">
                        <h3 className="text-grayAlohar w-max font-robotoRegular ">
                          {`${item.housing.location.location} ${
                            item.housing.location.id === 428
                              ? item.housing.neighborhood?.name
                              : ""
                          }`}
                        </h3>
                        <h2
                          className="text-[24px] leading-none truncate"
                          style={{ textTransform: "capitalize" }}
                        >
                          {item.housing.title}
                        </h2>
                        <h3 className="h-[50px]  leading-none font-robotoRegular">
                          {`${item.housing.description.substring(0, 110)} ${
                            item.housing.description.length >= 110
                              ? "..."
                              : ""
                          }`}
                        </h3>
                        <div>
                          {[0, 2].includes(item.status) && (
                            <del className="text-[24px] font-robotoRegular leading-none">
                              ${item.housing.basePrice}
                            </del>
                          )}
                          <p className="flex items-center gap-1 leading-none text-grayAlohar font-robotoRegular">
                            <span className="text-[32px]  text-primary font-robotoBold">
                              $
                              {[0, 2].includes(item.status)
                                ? truncar(
                                    item.housing.basePrice -
                                      (item.housing.basePrice *
                                        item.discount) /
                                      100,
                                    2
                                  )
                                : `${Intl.NumberFormat("de-AR").format(
                                    item.housing.basePrice
                                  )}`}
                            </span>
                            / Noche
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                    );
                  })()}
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="housing-promotions-pagination mt-4 flex justify-center"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HousingPromotions;
